/* Thankful PDP — Shopify build. Cart runs on Shopify's AJAX Cart API. */
(function () {
  'use strict';
  var root = document.querySelector('.tkf');
  if (!root) return;
  var $  = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = window.TKF_CONFIG || {};
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  var toastEl = $('#tkfToast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  var revealSel = ['.gallery','.buy','.ingr-band-copy','.ingr-band .logo-img','.ingr-list',
    '.nf-panel','.nots','.read-aloud','.inside-h','.inside-sub','.ic','.solve-h','.solve-sub',
    '.ba-col','.cmp-row','.solve-kicker','.btn--try','.rev-h','.rev-score','.rev-mid','.ugc',
    '.rev-tabs','.rev-tools','.star-filters','.placeholder-note','.rcard','.grat-h','.grat-card',
    '.grat-heart','.grat-side','.grat-cta'].join(',');
  $$(revealSel).forEach(function (el) {
    el.setAttribute('data-reveal','');
    var sibs = Array.prototype.slice.call(el.parentNode.children)
      .filter(function (n) { return n.hasAttribute && n.hasAttribute('data-reveal'); });
    var i = sibs.indexOf(el);
    if (i > 0 && i < 6) el.setAttribute('data-d', String(i));
  });
  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
  $$('[data-reveal]').forEach(function (el) { revealIO.observe(el); });

  function watch(sel, cls, thr) {
    var el = $(sel); if (!el) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); } });
    }, { threshold: thr || 0.35 });
    io.observe(el);
  }
  watch('#tkfStats','is-live',0.5); watch('#tkfBars','in',0.4); watch('.inside','in',0.15);

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var suffix = el.getAttribute('data-suffix') || '';
    if (REDUCED || isNaN(target)) return;
    var start = performance.now(), dur = 1100;
    (function step(now) {
      var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec) + suffix;
    })(performance.now());
  }
  var countIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); countIO.unobserve(e.target); } });
  }, { threshold: 0.6 });
  $$('[data-count]').forEach(function (el) { countIO.observe(el); });

  var stage = $('#tkfStage'), stageImg = $('#tkfStageImg');
  $$('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumb').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected','false'); });
      t.classList.add('is-active'); t.setAttribute('aria-selected','true');
      t.classList.contains('thumb--cut') ? stage.classList.add('stage--cut') : stage.classList.remove('stage--cut');
      stage.classList.add('is-swapping');
      setTimeout(function () {
        stageImg.src = t.getAttribute('data-full');
        stageImg.alt = t.getAttribute('data-alt') || '';
        stage.classList.remove('is-swapping');
      }, 190);
    });
  });
  if (stage) stage.addEventListener('pointermove', function (e) {
    var r = stage.getBoundingClientRect();
    stage.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
    stage.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
  });

  var ship = $('#tkfShipDate');
  if (ship) {
    var d = new Date(); d.setDate(d.getDate() + 5);
    ship.textContent = d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' });
  }

  var STATE = { id: CFG.defaultVariantId, qty: 1, plan: null };
  var priceEl = $('#tkfBundlePrice');

  function applyTier(t, silent) {
    if (!t) return;
    $$('.tier').forEach(function (o) { o.classList.remove('is-active'); });
    t.classList.add('is-active');
    STATE.id = t.getAttribute('data-vid');
    STATE.qty = 1;
    if (priceEl) priceEl.textContent = money(parseInt(t.getAttribute('data-price'), 10));
    if (!silent) {
      var save = t.getAttribute('data-save');
      toast(save && save !== '0' ? 'You save ' + money(parseInt(save, 10)) + ' on this bundle.' : 'Single box selected.');
    }
  }
  function selectPlan(which) {
    $$('.plan').forEach(function (p) {
      var on = p.getAttribute('data-plan') === which;
      p.classList.toggle('is-selected', on);
      var input = $('input', p); if (input) input.checked = on;
    });
    if (which === 'once') { STATE.id = CFG.singleVariantId; STATE.qty = 1; }
    else { applyTier($('.tier.is-active'), true); }
  }
  $$('.plan').forEach(function (p) {
    p.addEventListener('click', function (e) {
      if (e.target.closest('.tier') || e.target.closest('select')) return;
      selectPlan(p.getAttribute('data-plan'));
    });
  });
  $$('.tier').forEach(function (t) {
    t.addEventListener('click', function (e) { e.stopPropagation(); selectPlan('bundle'); applyTier(t); });
  });
  var freq = $('#tkfFreq');
  if (freq) freq.addEventListener('change', function () { STATE.plan = this.value || null; });
  selectPlan('bundle');

  var cartEl = $('#tkfCart'), scrim = $('#tkfScrim'), cartBody = $('#tkfCartBody'),
      cartTotal = $('#tkfCartTotal'), cartShip = $('#tkfCartShip');
  var FREE_SHIP = (CFG.freeShipThreshold || 40) * 100;

  function openCart() {
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-on'); });
    cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    scrim.classList.remove('is-on');
    cartEl.classList.remove('is-open'); cartEl.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    setTimeout(function () { scrim.hidden = true; }, 400);
  }
  $('#tkfCartClose').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartEl.classList.contains('is-open')) closeCart(); });

  function render(cart) {
    if (!cart.items || !cart.items.length) {
      cartBody.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    } else {
      cartBody.innerHTML = cart.items.map(function (i) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : CFG.fallbackImage;
        return '<div class="ci">' +
          '<img src="' + img + '" alt="">' +
          '<div><div class="ci-n">' + i.product_title + '</div>' +
          '<div class="ci-m">' + (i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + '</div>' +
          '<div class="qty"><button type="button" data-line="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease">−</button>' +
          '<b>' + i.quantity + '</b>' +
          '<button type="button" data-line="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<div class="ci-p">' + money(i.final_line_price) + '</div></div>';
      }).join('');
    }
    cartTotal.textContent = money(cart.total_price || 0);
    var left = FREE_SHIP - (cart.total_price || 0);
    cartShip.textContent = left > 0 ? 'Add ' + money(left) + ' for free shipping.' : 'Free shipping unlocked. Nice.';
    $$('[data-line]', cartBody).forEach(function (b) {
      b.addEventListener('click', function () { change(b.getAttribute('data-line'), b.getAttribute('data-q')); });
    });
  }
  function refresh() { return fetch('/cart.js', { credentials:'same-origin' }).then(function (r) { return r.json(); }).then(render); }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id:key, quantity: parseInt(qty,10) })
    }).then(function (r) { return r.json(); }).then(render);
  }
  function addToCart(id, qty, plan, btn) {
    if (!id) { toast('This option is not set up yet.'); return; }
    var item = { id: Number(id), quantity: qty || 1 };
    if (plan) item.selling_plan = Number(plan);
    if (btn) { btn.disabled = true; }
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; }
        if (!res.ok) { toast(res.j.description || res.j.message || 'Could not add to cart.'); return; }
        if (btn) {
          btn.classList.add('is-added');
          var lbl = btn.querySelector('.btn-label'), old = lbl.textContent;
          lbl.textContent = 'ADDED ✓';
          setTimeout(function () { btn.classList.remove('is-added'); lbl.textContent = old; }, 1600);
        }
        return refresh().then(openCart);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; }
        toast('Network hiccup — try again.');
      });
  }

  var atc = $('#tkfAtc');
  if (atc) atc.addEventListener('click', function () { addToCart(STATE.id, STATE.qty, STATE.plan, atc); });
  var tryBtn = $('#tkfTry');
  if (tryBtn) tryBtn.addEventListener('click', function () { addToCart(CFG.starterVariantId, 1, null, tryBtn); });
  var gratBtn = $('#tkfGrat');
  if (gratBtn) gratBtn.addEventListener('click', function () { addToCart(STATE.id, STATE.qty, STATE.plan, gratBtn); });
  var checkout = $('#tkfCheckout');
  if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
  refresh();

  $$('[data-ic]').forEach(function (card) {
    var btn = $('.ic-toggle', card);
    function toggle() { var open = card.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(open)); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    $('.ic-bubble', card).addEventListener('click', toggle);
  });

  var revList = $('#tkfRevList'), revEmpty = $('#tkfRevEmpty'), activeTopic = 'all';
  function filterReviews() {
    var q = ($('#tkfRevSearch').value || '').trim().toLowerCase(), shown = 0;
    $$('.rcard', revList).forEach(function (c) {
      var ok = (activeTopic === 'all' || c.getAttribute('data-topic') === activeTopic) &&
               (!q || c.textContent.toLowerCase().indexOf(q) > -1);
      c.style.display = ok ? '' : 'none'; if (ok) shown++;
    });
    revEmpty.hidden = shown !== 0;
  }
  $('#tkfRevSearch').addEventListener('input', filterReviews);
  $$('.sf').forEach(function (b) {
    b.addEventListener('click', function () {
      activeTopic = b.getAttribute('data-topic');
      $$('.sf').forEach(function (o) { o.classList.remove('is-active'); });
      b.classList.add('is-active'); filterReviews();
    });
  });
  $$('.rtab').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.rtab').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected','false'); });
      t.classList.add('is-active'); t.setAttribute('aria-selected','true');
      if (t.getAttribute('data-tab') === 'questions') {
        revList.style.display = 'none'; revEmpty.hidden = false;
        revEmpty.textContent = 'No questions yet. Ask one and a human answers it.';
      } else {
        revList.style.display = ''; revEmpty.textContent = 'No calls match that filter.'; filterReviews();
      }
    });
  });
  $$('.vote').forEach(function (v) {
    v.addEventListener('click', function () {
      var n = $('b', v), cur = parseInt(n.textContent, 10);
      n.textContent = String(v.classList.toggle('is-on') ? cur + 1 : Math.max(0, cur - 1));
    });
  });
  var revMore = $('#tkfRevMore');
  if (revMore) revMore.addEventListener('click', function () {
    var p = this.previousElementSibling;
    if (p.classList.contains('is-more')) {
      p.textContent = 'Fans love the satisfying taste, portable size, and how it helps curb cravings on the go.';
      p.classList.remove('is-more'); this.textContent = 'Read more';
    } else {
      p.textContent = 'Fans love the satisfying taste, portable size, and how it helps curb cravings on the go. ' +
        'Reviewers most often mention the chocolate melting rather than coating, a thick peanut butter centre, ' +
        'and one pack being enough to end a craving. The most common note in lower ratings is wanting a larger pack.';
      p.classList.add('is-more'); this.textContent = 'Read less';
    }
  });
  var wr = $('#tkfWriteReview');
  if (wr) wr.addEventListener('click', function () { toast('Review form connects with your reviews app at launch.'); });
  $$('.ugc-cell').forEach(function (c) {
    c.addEventListener('click', function () { toast('Customer gallery — full lightbox comes with the real UGC set.'); });
  });

  var rail = $('#tkfFlavorRail');
  if (rail) {
    $('#tkfFNext').addEventListener('click', function () { rail.scrollBy({ left: 200, behavior: 'smooth' }); });
    $('#tkfFPrev').addEventListener('click', function () { rail.scrollBy({ left: -200, behavior: 'smooth' }); });
    $('#tkfFAll').addEventListener('click', function () { toast('Five flavors in the line. Full grid at launch.'); });
    $$('.flav').forEach(function (f) {
      f.addEventListener('click', function () {
        $$('.flav').forEach(function (o) { o.classList.remove('is-active'); });
        f.classList.add('is-active'); toast($('span', f).textContent + ' — coming soon.');
      });
    });
  }

  $$('.hot').forEach(function (h, i) {
    var tip = $('.hot-tip--' + (i + 1));
    if (!tip) return;
    h.addEventListener('mouseenter', function () { tip.classList.add('is-on'); });
    h.addEventListener('mouseleave', function () { tip.classList.remove('is-on'); });
    h.addEventListener('focus', function () { tip.classList.add('is-on'); });
    h.addEventListener('blur', function () { tip.classList.remove('is-on'); });
    h.addEventListener('click', function () { tip.classList.toggle('is-on'); });
  });

  var toTop = $('#tkfToTop');
  window.addEventListener('scroll', function () {
    if (toTop) toTop.classList.toggle('is-on', (window.scrollY || 0) > 900);
  }, { passive: true });
  if (toTop) toTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
  });

  if (!REDUCED) {
    var pxEls = $$('.ic-photo, .grat-heart img, .ba-col img');
    var band = $('.brandband img'), bandBox = $('.brandband'), ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        pxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          el.style.translate = '0 ' + (((r.top + r.height/2 - vh/2) / vh) * -12).toFixed(2) + 'px';
        });
        if (band && bandBox) {
          var br = bandBox.getBoundingClientRect();
          if (br.bottom > 0 && br.top < vh)
            band.style.setProperty('--bandy', ((((br.top + br.height/2 - vh/2) / vh)) * -26).toFixed(1) + 'px');
        }
        ticking = false;
      });
    }, { passive: true });
  }
})();